export default "__VITE_ASSET__50fec1a3__"